"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const btoa_1 = __importDefault(require("btoa"));
exports.encodeState = (state) => {
    try {
        if (window) {
            return window.btoa(JSON.stringify(state));
        }
        else {
            return btoa_1.default(JSON.stringify(state));
        }
    }
    catch (ex) {
        return null;
    }
};
exports.decodeState = (encodedState) => {
    try {
        return JSON.parse(window.atob(encodedState));
    }
    catch (ex) {
        return null;
    }
};
exports.extractStateFromUrl = (key = "state") => {
    try {
        const searchParams = new URLSearchParams(window.location.search);
        const param = searchParams.get(key);
        if (param)
            return exports.decodeState(param);
    }
    catch (ex) {
        //expected on server side and also when no state
    }
    return null;
};
exports.generateUrl = (state, prefix, key = "state") => {
    const encoded = exports.encodeState(state);
    return prefix + `?${key}=` + encoded;
};
exports.generateUrlForThisPage = (state, key = "state") => {
    try {
        return exports.generateUrl(state, window.location.origin + window.location.pathname, key);
    }
    catch (ex) {
        return "";
    }
};
exports.twitterShare = (message, url) => `http://twitter.com/share?text=${encodeURI(message)}&url=${url}`;
exports.facebookShare = (url) => `http://www.facebook.com/sharer/sharer.php?u=${url}`;



// WEBPACK FOOTER //
// ./src/data/share.ts